function searchVariants(){
    let ident_search = 0;
    const searchForms = document.querySelectorAll('.search-block__form .form-control');
    searchForms.forEach(form => {
        form.addEventListener("input", function() {
            ident_search = this.parentElement.id;
            if (this.value.length > 3) {
                fetch("/classes/ajax/search/search.php", {
                    method: "POST",
                    body: JSON.stringify({gosearch: this.value}),
                    headers: {"Content-type": "application/json; charset=UTF-8"}
                })
                    .then(response => response.text())
                    .then(response => {
                        const searchWrapper = document.querySelector(`#${ident_search}`).closest(".search-block");
                        searchWrapper.querySelector(".search-block__variants").innerHTML = response;
                        searchWrapper.querySelectorAll(".search-block__option").forEach(option => {
                            option.addEventListener("click", function(e) {
                                const textInput = searchWrapper.querySelector(`#${ident_search} .form-control`);
                                textInput.value = this.textContent;
                                searchWrapper.querySelector(`#${ident_search}`).submit();
                            });
                        });
                        searchWrapper.querySelector(".search-block__variants").style.display = "block";
                    })
                    .catch(error => console.error(error));
            } else {
                document.querySelector(`#${ident_search}`).closest(".search-block").querySelector(".search-block__variants").innerHTML = '';
                document.querySelector(`#${ident_search}`).closest(".search-block").querySelector(".search-block__variants").style.display = "none";
            }
        });
    });
}

export default searchVariants;